<template>
  <div class="details afterType">
    <header>
      <p>
        <img
          :src="
            list.apply_status == 5
              ? require('../../assets/images/right.png')
              : list.apply_status == 6
              ? require('../../assets/images/close2.png')
              : list.apply_status == 2
              ? require('../../assets/images/refund1.png')
              : list.apply_status == 3
              ? require('../../assets/images/sendgood.png')
              : require('../../assets/images/order.png')
          "
        />
        {{ list.title1 }}
      </p>
      <span>
        {{ list.title2 }}
        {{ list.minutes > 0 && list.apply_status == 1 ? '剩余' : '' }}
        <van-count-down
          style="display: inline-block; color: #ffefed"
          v-if="list.minutes > 0"
          :time="list.minutes * 1000 * 60"
          format="HH 时 mm 分"
        />
      </span>
    </header>
    <div class="refundMoney">
      <p>
        退款金额
        <b>¥{{ list.refund_money }}</b>
      </p>
      <p v-if="list.refund_account && list.apply_status == 5" style="margin-top: 0.1rem">
        退款账户
        <b style="font-size: 0.13rem; color: #3a393a">{{ list.refund_account }}</b>
      </p>
      <div class="refundFlow">
        <p></p>
        <ul>
          <li class="redStyle">
            <b>
              <img
                :src="
                  list.apply_status == 1 || list.apply_status == 6
                    ? require('../../assets/images/waitprocess.png')
                    : require('../../assets/images/success.png')
                "
              />
            </b>
            <span>
              {{
                list.apply_status == 1
                  ? '等待售后处理'
                  : list.apply_status == 6
                  ? '售后处理'
                  : '审核已通过'
              }}
            </span>
          </li>
          <!--<li :class="{'redStyle': styleShow}" v-else-if="!styleShowWait"><b><img :src="styleShow ? require('../../assets/images/success.png'):require('../../assets/images/successgray.png')"></b><span>审核已通过</span></li>-->
          <li v-if="list.apply_status != 6" :class="{ redStyle: list.apply_status != 1 }">
            <b>
              <img
                :src="
                  list.apply_status != 1
                    ? require('../../assets/images/bankcard.png')
                    : require('../../assets/images/bankcardgray.png')
                "
              />
            </b>
            <span>退款中</span>
          </li>
          <li :class="{ redStyle: list.apply_status == 5 || list.apply_status == 6 }">
            <b>
              <img
                :src="
                  list.apply_status == 5
                    ? require('../../assets/images/success.png')
                    : list.apply_status == 6
                    ? require('../../assets/images/turndown1.png')
                    : require('../../assets/images/successgray.png')
                "
              />
            </b>
            <span>{{ list.apply_status == 6 ? '售后拒绝' : '退款成功' }}</span>
          </li>
          <!--<li :class="{'redStyle': styleShowWait}" v-else-if="styleShowWait"><b><img src="../../assets/images/turndown1.png"></b><span>售后拒绝</span></li>-->
        </ul>
      </div>
    </div>
    <div class="address" v-if="list.trans_status == 2">
      <ul>
        <li>
          <p @click="querylogistics('query')">
            <img src="../../assets/images/logistics.png" />
            点击查看物流信息
            <van-icon name="arrow" size="0.1rem" color="#000000" />
          </p>
          <span>{{ list.trans_time }}</span>
        </li>
        <li>
          <p>
            <img src="../../assets/images/position.png" style="padding: 0.01rem 0.02rem" />
            {{ list.service_name ? list.service_name : '售后部收' }}&nbsp;&nbsp;{{
              list.service_phone
            }}
          </p>
          <span style="font-size: 0.11rem; color: #959595">{{ list.servcie_address }}</span>
        </li>
      </ul>
    </div>
    <!--list.type == 2 && (tips && tips.title)-->
    <div class="refundMoney applyFor" v-if="tips && tips.title">
      <p>{{ tips.title }}</p>
      <ul v-if="tips && tips.children">
        <li class="f12" v-for="(item, index) in tips.children" :key="index">{{ item }}</li>
      </ul>
      <div
        v-if="list.apply_status == 2 || (list.apply_status == 5 && list.showexpr == 1)"
        class="revice-address"
      >
        <div class="f12 mb4 fw-b">收件地址</div>
        <div class="flex f12">
          <div class="pt2">
            <van-icon class="ml4 mr4" size="16px" name="location-o" />
          </div>
          <div class="flex-1 flex fd-c">
            <div class="flex f12 fw-b">
              <span>{{ list.service_name }}</span>
              <span>{{ list.service_phone }}</span>
              <span class="flex-1 ta-r color-599AF4" @click="copyAddress">复制</span>
            </div>
            <div class="color-6">
              <span>{{ list.servcie_address }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="proBtn">
        <button class="grayBtn" v-if="list.apply_status == 1" @click="withdraw">撤销申请</button>
        <button class="grayBtn" v-if="list.apply_status == 3" @click="querylogistics('query')">
          查询物流
        </button>
        <button class="redBtn" v-if="list.apply_status == 1" @click="update">修改申请</button>
        <button
          class="redBtn"
          v-if="list.apply_status == 2 || (list.apply_status == 5 && list.showexpr == 1)"
          @click="querylogistics('write')"
        >
          填写物流
        </button>
        <button class="redBtn" v-if="list.apply_status == 6" @click="afterSalesFn">重新申请</button>
      </div>
    </div>
    <div class="list">
      <ul>
        <li>
          <div
            class="product"
            v-for="(item, index) of list.item_list"
            :key="index"
            @click="productDetailFn(item)"
          >
            <div class="productBox">
              <div class="productImg">
                <img v-lazy="item.img_path" />
                <goods-tag :goods="item"></goods-tag>
              </div>
              <div class="proContent">
                <b>{{ item.name.length > 26 ? item.name.slice(0, 26) + '...' : item.name }}</b>
                <p>
                  <b>{{ item.spec }}</b>
                </p>
                <!--<div class="choicesNum">-->
                <!--<van-stepper-->
                <!--v-model="value"-->
                <!--input-width="35"-->
                <!--/>-->
                <!--</div>-->
              </div>
            </div>
            <!--<div v-else-if="item.tranStatus==1" class="productBox bestSellingSwiper" style="overflow: hidden;position:relative;">-->
            <!--<swiper :options="swiperOption" ref="mySwiper">-->
            <!--<swiper-slide v-for="(itemSon, idx) of item.imgUrl" :key="idx">-->
            <!--<img :src="itemSon">-->
            <!--</swiper-slide>-->
            <!--</swiper>-->
            <!--</div>-->
            <span class="totelPrice">
              <span class="price">
                {{
                  String(parseFloat(item.back_price).toFixed(2)).slice(
                    0,
                    String(parseFloat(item.back_price).toFixed(2)).indexOf('.')
                  )
                }}
                <i>
                  {{
                    String(parseFloat(item.back_price).toFixed(2)).slice(
                      String(parseFloat(item.back_price).toFixed(2)).indexOf('.'),
                      String(parseFloat(item.back_price).toFixed(2)).length
                    )
                  }}
                </i>
              </span>
              <b>共{{ item.num }}件</b>
            </span>
          </div>
          <div class="proFooter" @click="keFu">
            <p>
              <img src="../../assets/images/kefu.png" />
              联系客服
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="orderSource">
      <ul>
        <li>
          <i>退款原因：</i>
          <b>{{ list.reason_name }}</b>
        </li>
        <li>
          <i>退款类型：</i>
          <b>{{ list.type_name }}</b>
        </li>
        <li>
          <i>退款金额：</i>
          <b>¥{{ list.refund_money }}</b>
        </li>
        <li v-if="parseInt(list.depositmoney) > 0">
          <i>定金：</i>
          <b>{{ list.depositmoney }}元</b>
        </li>
        <li v-if="parseInt(list.refund_discountcoupon_money) > 0">
          <i>折扣券：</i>
          <b>{{ list.refund_discountcoupon_money }}元</b>
        </li>
        <li v-if="parseInt(list.refund_coupon_money) > 0">
          <i>现金券：</i>
          <b>{{ list.refund_coupon_money }}元</b>
        </li>
        <li v-if="parseInt(list.refund_integer_number) > 0">
          <i>金币：</i>
          <b>{{ list.refund_integer_number }}</b>
        </li>
        <li v-if="couponname">
          <i>产品券：</i>
          <b>{{ couponname }}</b>
        </li>
        <li>
          <i>申请数量：</i>
          <b>{{ list.nums }}件</b>
        </li>
        <li>
          <i>申请时间：</i>
          <b>{{ list.apply_time }}</b>
        </li>
      </ul>
    </div>
    <footer class="footerIOS">
      <div class="proBtn">
        <button
          class="grayBtn"
          v-if="list.apply_status == 5 || list.apply_status == 6"
          @click="evaluate"
        >
          售后评价
        </button>
        <button
          v-if="list.is_act_order != 1 && list.isdeposit != 1 && list.isMayTwentyAct != 1"
          class="redBtn"
          @click="buyAgain"
        >
          再次购买
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, kefu, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
import goodsTag from '../common/goodsTag'
Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'afterDetails',
  components: {
    goodsTag
  },
  data() {
    return {
      id: this.$route.query.id ? this.$route.query.id : '',
      message: this.$route.query.message ? this.$route.query.message : '',
      styleShow: false,
      styleShowWait: false,
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
      list: [],
      tips: {
        title: '',
        children: []
      },
      couponname: ''
    }
  },
  mounted: function () {
    let message = this.message
    if (message) {
      this.$toast(message)
    }
    if (isWeixin()) {
      fenxiang({ path: 'afterdetails' })
    }
    this.getData()
    // 挂载完成后，判断浏览器是否支持popstate
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed() {
    this.$toast.clear()
    this.$dialog.close()
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    getData() {
      var url = this.$ajax.getRefundOrderInfo_URL + '?id=' + this.id
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          for (var i in res.data.item_list) {
            if (res.data.item_list[i].couponname) {
              that.couponname = res.data.item_list[i].couponname
            }
          }
          that.list = res.data
          if (that.list.apply_status == 1) {
            if (that.list.type == 1) {
              that.tips = {
                title: '您已成功发起售后申请，请耐心等待售后处理…',
                children: [
                  '售后被拒绝后，可修改售后申请再次提交',
                  '申请售后时，上传必要的图片将提高通过率'
                ]
              }
            } else {
              that.tips = {
                title: '您已成功发起售后申请，请耐心等待售后处理…',
                children: [
                  '售后通过后，请按照售后给出的售后地址进行退货，并记录退货单号',
                  '售后被拒绝后，可修改售后申请再次提交',
                  '申请售后时，上传必要的图片将提高通过率'
                ]
              }
            }
          } else if (
            that.list.apply_status == 2 ||
            (that.list.apply_status == 5 && that.list.showexpr == 1)
          ) {
            that.tips = {
              title: '退款审核通过，请尽快寄回快递',
              children: ['退款审核已通过，点击下方“填写物流”完成后续操作']
            }
          } else if (that.list.apply_status == 3) {
            that.tips = {
              title: '等待卖家收货，核对无误后开始原路返回金额',
              children: [
                '卖家收货后，核对快递内容物真实有效且不影响二次销售即开始退款',
                '对部分质量等问题，经协商一致的退款申请，无需参考二次销售等指标'
              ]
            }
          } else if (that.list.apply_status == 6) {
            that.tips = {
              title: '您发起的售后申请，被拒绝',
              children: [that.list.deny_reason]
            }
          }
        }
      })
    },
    withdraw() {
      var url = this.$ajax.cancelRefundOrder_URL
      var data = {
        id: this.list.id
      }
      var that = this
      if (that.list.drawordermsg != '') {
        that.$dialog
          .alert({
            title: '',
            message: that.list.drawordermsg,
            className: 'percen_button_alert',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '我知道了',
            closeOnPopstate: false
          })
          .then(function () {
            // on confirm
          })
        return
      }
      that.$dialog
        .confirm({
          message: '撤销后售后将停止处理',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          closeOnPopstate: true
        })
        .then(function () {
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              that.$toast('撤销成功')
              // that.getData()
              setTimeout(function () {
                // that.$router.go(-1)
                that.$router.replace({
                  path: '/myorder'
                })
              }, 100)
            }
          })
        })
        .catch(function () {
          // on cancel
        })
    },
    update() {
      var that = this
      that.$dialog
        .confirm({
          message: '修改售后申请重新提交后，售后将重新计时重新处理',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          closeOnPopstate: true
        })
        .then(function () {
          that.$router.push({
            path: '/salesreturn',
            query: {
              id: that.list.id
            }
          })
        })
        .catch(function () {
          // on cancel
        })
    },
    // logistics () {
    //   this.$router.replace({
    //     path: '/retsubs',
    //     query: {
    //       id: this.id,
    //       type: type
    //     }
    //   })
    // },
    productDetailFn(items) {
      if (items.limitid) {
        let linkParams = 'limitid=' + items.limitid
        if (items.limit_new == 1) {
          linkParams += '&ad_v=2&itemid=' + items.itembaseid
        }
        window.location.href =
          '/static/wx/html/time-limit-actpage/timelimitproduct.html?' + linkParams
      } else if (items.integralitemid && items.integralitemid != '') {
        this.$router.push({
          path: '/integralproduct',
          query: {
            itemid: items.integralitemid,
            integralType: items.integraltype == 1 ? 0 : 1,
            integral: items.integralcount,
            status: items.integralstatus,
            itembaseid: items.itembaseid
          }
        })
      } else if (
        this.list.is_coupon != 1 &&
        items.isgoiteminfo == 1 &&
        items.isadditem != 1 &&
        items.isprogift == 0 &&
        items.ischangebuy == 0 &&
        items.isgift == 0 &&
        items.isexchangebuy != 1
      ) {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: {
            itemid: items.itembaseid,
            scenepoint: 'REFUNDDETAIL',
            scenedesc: this.id
          }
        })
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: items.itembaseid
          }
        })
      } else if (items.ischangebuy == 1 || items.isexchangebuy == 1 || items.isgift == 1) {
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: items.itembaseid,
            type: 'changebuyproductdetail',
            gift: items.isgift ? 'gift' : ''
          }
        })
      }
    },
    querylogistics(type) {
      this.$router.replace({
        path: '/retsubs',
        query: {
          id: this.id,
          type: type
        }
      })
    },
    copyAddress: async function () {
      try {
        // 微信H5兼容处理
        const addressStr = `${this.list.service_name} ${this.list.service_phone} ${this.list.servcie_address}`
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(addressStr)
        } else {
          // 创建临时输入框实现复制
          const textarea = document.createElement('textarea')
          textarea.value = addressStr
          textarea.style.position = 'fixed'
          document.body.appendChild(textarea)
          textarea.select()
          // 兼容iOS微信
          if (navigator.userAgent.match(/iphone|ipad|ipod/i)) {
            textarea.setSelectionRange(0, addressStr.length)
          }
          // 执行复制命令
          const result = document.execCommand('copy')
          document.body.removeChild(textarea)

          if (!result) {
            throw new Error('复制失败')
          }
        }
        this.$toast('地址已复制到剪贴板')
      } catch (err) {
        console.error('复制链接到剪切板时出错:', err)
      }
    },
    buyAgain: function () {
      var url = this.$ajax.addShoppingCart_URL
      var skuId = []
      var itemnum = []
      var liveId = []
      var list = this.list.item_list
      this.list.item_list.map((item) => {
        if (
          item.isgift == 0 &&
          !item.isadditem &&
          item.ischangebuy == 0 &&
          item.isexchangebuy == 0
        ) {
          skuId.push(item.skuid)
          itemnum.push(item.num)
          liveId.push(item.live_id)
        }
      })
      var data = {
        skuid: skuId.join(),
        itemnum: itemnum.join(),
        live_ids: liveId.join()
      }
      if (!data.skuid.length) {
        this.$router.push('/cart')
        return
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          this.$store.commit('ADD_CART_INIT_DATA', 1)
          this.dataCollection(list)
          this.$router.push('/cart')
        }
      })
    },
    // 埋点-加入购物车
    dataCollection(list) {
      let params
      for (let i in list) {
        if (list[i].isgift == 0 && list[i].isadditem == 0 && list[i].ischangebuy == 0) {
          params = {
            productId_var: '',
            productName_var: list[i].name,
            firstCat_var: '',
            productType_var: '',
            productFormat_var: list[i].skuid
          }

          console.log(params)
          gio('track', 'addToCart', params)
        }
      }
    },
    evaluate: function () {
      this.$router.push('/aftereval')
      sessionStorage.setItem('evaluate_after_product', JSON.stringify(this.list))
    },
    afterSalesFn: function () {
      var returnType, type
      if (this.list.type == 1) {
        returnType = 'refund'
      } else {
        returnType = 'refundSales'
      }
      if (this.list.item_list && this.list.item_list.length == 1) {
        type = 0
      } else if (this.list.item_list && this.list.item_list.length > 1) {
        type = 1
      }
      sessionStorage.setItem('refundSales_data', JSON.stringify(this.list.item_list))
      this.$router.push({
        path: '/refundsales',
        query: {
          returnType: returnType,
          id: this.list.orderid,
          type: type
        }
      })
    },
    // 客服
    keFu: function () {
      var goodslist = [],
        goodsnum = 0
      this.list.item_list.map((item) => {
        goodslist.push({
          name: item.name,
          pictureUrl: encodeURIComponent(item.img_path)
        })
        goodsnum += parseInt(item.num)
      })
      var k =
        'order_status=0&status_custom=' +
        this.list.orderstatus_text +
        '&create_time=' +
        new Date(this.list.ordertime.replace(/-/g, '/')).getTime() +
        '&order_code=' +
        this.list.no +
        '&order_url=' +
        encodeURIComponent(window.location.href) +
        '&goods_count=' +
        goodsnum +
        '&total_fee=' +
        parseInt(parseFloat(this.list.pay_money) * 100) +
        '&goods=' +
        JSON.stringify(goodslist)
      kefu(1, k)
    },
    goBack() {
      // 个人中心进入返回上一级，支付后进入返回首页
      if (this.$route.query.route) {
        this.$router.replace({ path: '/' })
      } else {
        history.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.list ul li p,
.list ul li .proFooter,
.product,
.type ul li {
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -o-flex;
  justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -webkit-justify-content: space-between;
  -o-justify-content: space-between;
  align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
}
.details {
  padding-bottom: 0.46rem;
  header {
    height: 1.15rem;
    background: linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    background: -webkit-linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    background: -ms-linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    background: -o-linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    background: -moz-linear-gradient(108deg, rgba(252, 3, 36, 1) 0%, rgba(238, 116, 47, 1) 100%);
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    -moz-flex-direction: column;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    -moz-justify-content: center;
    p {
      font-size: 0.18rem;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 0.25rem;
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      justify-content: center;
      -webkit-justify-content: center;
      -ms-justify-content: center;
      -o-justify-content: center;
      -moz-justify-content: center;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      margin-bottom: 0.07rem;
      img {
        margin-right: 0.08rem;
        width: 0.18rem;
        height: 0.18rem;
      }
    }
    span {
      display: block;
      font-size: 0.12rem;
      font-weight: 600;
      color: rgba(255, 239, 237, 1);
      line-height: 0.17rem;
      text-align: center;
    }
  }
  .refundMoney {
    padding: 0.14rem 0.15rem 0.35rem;
    margin: 0.1rem 0.11rem 0;
    background: #fff;
    border-radius: 0.03rem;
    > p {
      font-size: 0.13rem;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      line-height: 0.18rem;
      > b {
        font-size: 0.16rem;
        font-weight: 400;
        color: rgba(252, 3, 36, 1);
        line-height: 0.22rem;
        float: right;
      }
    }
    .refundFlow {
      position: relative;
      margin-top: 0.17rem;
      > p {
        height: 0.01rem;
        background: #eeeeee;
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
      }
      ul {
        display: flex;
        display: -o-flex;
        display: -webkit-flex;
        display: -ms-flex;
        display: -moz-flex;
        justify-content: space-between;
        -o-justify-content: space-between;
        -webkit-justify-content: space-between;
        -ms-justify-content: space-between;
        -moz-justify-content: space-between;
        padding-left: 0.27rem;
        padding-right: 0.27rem;
        width: 100%;
        li {
          position: relative;
          b {
            display: block;
            height: 0.2rem;
            img {
              height: 0.2rem;
              width: 0.2rem;
              border-radius: 50%;
              margin: 0 auto;
            }
          }
          span {
            position: absolute;
            left: 50%;
            -webkit-transform: translateX(-50%);
            -o-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            transform: translateX(-50%);
            white-space: nowrap;
            margin-top: 0.09rem;
            display: block;
            font-size: 0.11rem;
            font-weight: 400;
            color: rgba(210, 210, 210, 1);
            line-height: 0.16rem;
          }
          &.redStyle {
            b {
              img {
                box-shadow: 0 0.02rem 0.04rem 0 rgba(217, 186, 190, 1);
                -o-box-shadow: 0 0.02rem 0.04rem 0 rgba(217, 186, 190, 1);
                -webkit-box-shadow: 0 0.02rem 0.04rem 0 rgba(217, 186, 190, 1);
                -ms-box-shadow: 0 0.02rem 0.04rem 0 rgba(217, 186, 190, 1);
                -moz-box-shadow: 0 0.02rem 0.04rem 0 rgba(217, 186, 190, 1);
              }
            }
            span {
              color: #fc0324;
            }
          }
        }
      }
    }
  }
  .address {
    background: #fff;
    border-radius: 0.03rem;
    padding: 0.2rem 0.23rem 0.2rem 0.15rem;
    margin: 0.1rem 0.11rem 0;
    ul {
      li {
        p {
          display: flex;
          display: -webkit-flex;
          display: -ms-flex;
          display: -o-flex;
          display: -moz-flex;
          align-items: center;
          -webkit-align-items: center;
          -ms-align-items: center;
          -o-align-items: center;
          -moz-align-items: center;
          font-size: 0.12rem;
          font-weight: 600;
          color: rgba(29, 30, 30, 1);
          line-height: 0.17rem;

          img {
            &:first-of-type {
              width: 0.18rem;
              height: 0.16rem;
              margin-right: 0.05rem;
            }
            &:last-of-type {
              width: 0.16rem;
              height: 0.16rem;
              /*padding: 0 0.015rem;*/
              /*margin-left: 0.05rem;*/
            }
          }
        }
        span {
          display: block;
          font-size: 0.1rem;
          font-weight: 400;
          color: rgba(134, 134, 134, 1);
          line-height: 0.14rem;
          margin-top: 0.06rem;
          padding-left: 0.23rem;
        }
        &:last-of-type {
          margin-top: 0.15rem;
        }
      }
    }
  }
  .applyFor {
    padding: 0.14rem 0.15rem 0.35rem;
    margin: 0.1rem 0.11rem 0;
    background: #fff;
    border-radius: 0.03rem;
    p {
      padding-bottom: 0.1rem;
      border-bottom: 1px solid #d8d8d8;
    }
    ul {
      padding: 0.06rem 0 0.2rem 0.16rem;
      li {
        list-style-type: disc;
        margin-top: 0.05rem;
        font-size: 0.11rem;
        color: #959595;
      }
    }
    .revice-address {
      margin-top: -12px;
      margin-bottom: 12px;
    }
    .proBtn {
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -o-flex;
      justify-content: flex-end;
      -moz-justify-content: flex-end;
      -ms-justify-content: flex-end;
      -webkit-justify-content: flex-end;
      -o-justify-content: flex-end;
      .grayBtn {
        min-width: 0.7rem;
        height: 0.27rem;
        display: block;
        margin-left: 0.1rem;
        border-radius: 0.14rem;
        border: 1px solid rgba(96, 96, 96, 1);
        font-size: 0.12rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 0.17rem;
        padding: 0.05rem 0.11rem;
        background: none;
        outline: none;
      }
      .redBtn {
        min-width: 0.7rem;
        height: 0.27rem;
        display: block;
        margin-left: 0.1rem;
        border-radius: 0.14rem;
        border: 1px solid #fc0324;
        font-size: 0.12rem;
        font-weight: 400;
        color: #fc0324;
        line-height: 0.17rem;
        padding: 0.05rem 0.11rem;
        background: none;
        outline: none;
      }
      .grayBackBtn {
        min-width: 0.7rem;
        height: 0.27rem;
        display: block;
        margin-left: 0.1rem;
        background: rgba(221, 221, 221, 1);
        border-radius: 0.14rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: rgba(255, 252, 252, 1);
        line-height: 0.17rem;
        padding: 0.05rem 0.11rem;
        outline: none;
        border: 1px solid rgba(221, 221, 221, 1);
      }
    }
  }
  .list {
    > ul {
      margin-bottom: 0.11rem;
      > li {
        background: #fff;
        margin: 0.11rem 0.11rem 0;
        padding: 0.15rem 0.15rem 0;
        > p {
          border-bottom: 1px solid #efefef;
          padding-bottom: 0.1rem;
          span {
            display: block;
            b {
              display: block;
              font-weight: 400;
              color: #444444;
              font-size: 0.12rem;
              float: left;
              &:last-of-type {
                margin-left: 0.04rem;
              }
            }
          }
          i {
            font-style: normal;
            color: #292929;
            font-size: 0.12rem;
            display: flex;
            display: -o-flex;
            display: -webkit-flex;
            display: -ms-flex;
            display: -moz-flex;
            align-items: center;
            -o-align-items: center;
            -webkit-align-items: center;
            -ms-align-items: center;
            -moz-align-items: center;
            b {
              border-left: 1px solid #d8d8d8;
              margin-left: 0.06rem;
              padding-left: 0.07rem;
              display: flex;
              display: -o-flex;
              display: -webkit-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: center;
              -o-align-items: center;
              -webkit-align-items: center;
              -ms-align-items: center;
              -moz-align-items: center;
              img {
                width: 0.12rem;
                height: 0.12rem;
              }
            }
          }
        }
        .product {
          position: relative;
          margin-bottom: 0.1rem;
          &:last-of-type {
            margin-bottom: 0;
          }
          .productBox {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            .productImg {
              width: 0.8rem;
              height: 0.8rem;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .proContent {
              margin-left: 0.07rem;
              margin-top: 0.08rem;
              flex: 1;
              -webkit-flex: 1;
              -moz-flex: 1;
              -ms-flex: 1;
              -o-flex: 1;
              > b {
                font-size: 0.13rem;
                font-weight: 400;
                color: rgba(41, 41, 41, 1);
                line-height: 0.18rem;
                display: block;
                margin-bottom: 0.05rem;
              }
              > p {
                align-items: flex-start;
                -moz-align-items: flex-start;
                -ms-align-items: flex-start;
                -webkit-align-items: flex-start;
                -o-align-items: flex-start;
                > b {
                  font-size: 0.11rem;
                  font-weight: 400;
                  color: rgba(108, 108, 108, 1);
                  line-height: 0.16rem;
                  display: block;
                }
              }
              .choicesNum {
                height: 0.22rem;
                margin-top: 0.11rem;
              }
            }
          }
          .totelPrice {
            z-index: 10;
            opacity: 0.85;
            height: 0.8rem;
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            flex-direction: column;
            -webkit-flex-direction: column;
            -o-flex-direction: column;
            -ms-flex-direction: column;
            -moz-flex-direction: column;
            justify-content: center;
            -webkit-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            -moz-justify-content: center;
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: flex-end;
              -webkit-align-items: flex-end;
              -o-align-items: flex-end;
              -ms-align-items: flex-end;
              -moz-align-items: flex-end;
              font-size: 0.14rem;
              font-weight: 600;
              color: #222222;
              line-height: 0.14rem;
              &:before {
                content: '￥';
                font-size: 0.1rem;
                font-weight: 600;
                line-height: 0.14rem;
              }
              i {
                font-size: 0.11rem;
                font-style: normal;
                line-height: 0.14rem;
              }
            }
            > b {
              color: #908d8d;
              font-size: 0.11rem;
              line-height: 0.16rem;
              display: block;
              font-weight: 400;
              text-align: center;
            }
          }
          .bestSellingSwiper {
            .swiper-container {
              padding-right: 0.6rem;
            }
            .swiper-wrapper {
              .swiper-slide {
                width: 0.8rem;
                position: relative;
                background-color: white;
              }
            }
            & + .totelPrice {
              background: rgba(255, 255, 255, 1);
              box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
            }
          }
        }
        .proFooter {
          margin-top: 0.2rem;
          border-top: 1px solid rgba(216, 216, 216, 1);
          justify-content: center;
          height: 0.37rem;
          > p {
            font-size: 0.12rem;
            font-weight: 400;
            color: #363636;
            line-height: 0.17rem;
            padding: 0.1rem auto;
            img {
              width: 0.15rem;
              height: 0.15rem;
              margin-right: 0.04rem;
            }
          }
        }
      }
    }
  }
  .orderSource {
    background: #fff;
    margin: 0.1rem 0.11rem 0.1rem;
    padding: 0.2rem 0.15rem;
    border-radius: 0.03rem;
    ul {
      li {
        i {
          display: inline-block;
          font-style: normal;
          font-size: 0.12rem;
          font-weight: 400;
          color: rgba(61, 61, 61, 1);
          width: 0.6rem;
          white-space: nowrap;
        }
        font-size: 0.12rem;
        line-height: 0.17rem;
        margin-top: 0.1rem;
        &:first-of-type {
          margin-top: 0;
        }
        b {
          font-size: 0.12rem;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 0.17rem;
          margin-left: 0.15rem;
        }
        /*i {*/
        /*font-style: normal;*/
        /*font-size:0.1rem;*/
        /*font-weight:400;*/
        /*color:rgba(74,144,226,1);*/
        /*line-height:0.14rem;*/
        /*margin-left: 0.06rem;*/
        /*}*/
      }
    }
  }
  footer {
    border-top: 1px solid #bdbdbd;
    padding: 0 0.15rem;
    background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    /* border: 0; */
    bottom: 0;
    z-index: 10;
    .proBtn {
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -o-flex;
      justify-content: flex-end;
      -moz-justify-content: flex-end;
      -ms-justify-content: flex-end;
      -webkit-justify-content: flex-end;
      -o-justify-content: flex-end;
      button {
        margin: 0.09rem 0;
      }
      .grayBtn {
        min-width: 0.7rem;
        height: 0.27rem;
        display: block;
        margin-left: 0.1rem;
        border-radius: 0.14rem;
        border: 1px solid rgba(96, 96, 96, 1);
        font-size: 0.12rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 0.17rem;
        padding: 0.05rem 0.11rem;
        background: none;
        outline: none;
      }
      .redBtn {
        min-width: 0.7rem;
        height: 0.27rem;
        display: block;
        margin-left: 0.1rem;
        border-radius: 0.14rem;
        border: 1px solid #fc0324;
        font-size: 0.12rem;
        font-weight: 400;
        color: #fc0324;
        line-height: 0.17rem;
        padding: 0.05rem 0.11rem;
        background: none;
        outline: none;
      }
      .grayBackBtn {
        min-width: 0.7rem;
        height: 0.27rem;
        display: block;
        margin-left: 0.1rem;
        background: rgba(221, 221, 221, 1);
        border-radius: 0.14rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: rgba(255, 252, 252, 1);
        line-height: 0.17rem;
        padding: 0.05rem 0.11rem;
        outline: none;
        border: 1px solid rgba(221, 221, 221, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/after/afterDetails.vue